import React, { Component } from "react";
import "./news.css";
import Header from "../../components/page/header";
import Footer from "../../components/page/footer";
import Page from "../../components/page/page";
import NewsDesktop from "./newsDesktop";
import NewsMobile from "./newsMobile";

export default class news extends Component {
    constructor(props) {
        super(props);

        this.state = { width: 0 }
        this.setSize = this.setSize.bind(this);
    }
    setSize() {
        this.setState({
            width: window.innerWidth
        });
    }

    componentDidMount() {
        this.setSize();
        window.addEventListener('resize', this.setSize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.setSize);
    }

    render() {
        let content = this.state.width < 600 ? <NewsMobile /> : <NewsDesktop />;
        return (
            <Page >
                <Header />
                {content}
                <Footer />
            </Page >
        )
    }
}
